import { Typography } from 'antd';
import type * as React from 'react';
import {
  type IInputLikeWrapperProps,
  InputLikeWrapper,
} from './InputLikeWrapper.tsx';

export interface IInputLikeTextProps
  extends Omit<IInputLikeWrapperProps, 'children'> {
  text?: React.ReactNode;
}

export function InputLikeText(props: IInputLikeTextProps) {
  const { text, ...otherProps } = props;
  return (
    <InputLikeWrapper {...otherProps}>
      <Typography.Text ellipsis>{text}</Typography.Text>
    </InputLikeWrapper>
  );
}
